import { render, staticRenderFns } from "./BarrierSelect.vue?vue&type=template&id=5a431c81&"
import script from "./BarrierSelect.vue?vue&type=script&lang=js&"
export * from "./BarrierSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports